import React, { useEffect, useState } from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import './Calendar.css';


const Calendar = ({ fromMonth,toMonth, bookingDates=[], onDateSelect }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  
  useEffect(()=>{
    console.log("Booking Dates:", bookingDates);
  },[])

  const handleSelect = (date) => {
    setSelectedDate(date);
    if (onDateSelect) {
      onDateSelect(date);
    }
  };

  const today = new Date();
  const oneMonthLater = new Date();
  oneMonthLater.setDate(today.getDate() + 30);

  const isBookingDate = (date) => {
    const dateString = date.toLocaleDateString("en-CA");
    return bookingDates.includes(dateString);
  };
  
  return (
    <div className="bg-white flex flex-col items-center justify-center lg:mb-10 md:mx-auto">
      <div className="bg-white md:scale-125  md:p-4 md:shadow-xl">
        <DayPicker
          mode="single"
          showOutsideDays
          selected={selectedDate}
          onSelect={handleSelect}
          weekStartsOn={1}
          fromMonth={fromMonth}
          toMonth={toMonth}
          modifiers={{
            disabledBeforeToday: (date) => date < today,
            bookingDate: isBookingDate,
          }}
          modifiersClassNames={{
            disabledBeforeToday: 'text-gray-400', 
            selected: 'bg-teal-500 text-white rounded-full w-8 h-8',
            bookingDate: 'booking-date',
          }}
        />
      </div>
    </div>

  );
};

export default Calendar;
